import React, { useEffect, useRef } from "react";
import { CANVAS_W, CANVAS_H } from "../../../carousel/canvas";
import { drawSlide } from "../../../carousel/drawSlide";
import { drawBackground } from "../../../carousel/backgrounds";
import { buildTheme } from "../../../carousel/palettes";

// Thumbnails are drawn at 20% of the real slide (216 x 270 px): sharp enough
// for a small preview, light enough to draw several at once.
const SCALE = 0.2;

// A small, real rendering of one slide, used in the tool panels.
// options: everything drawSlide needs (slide, index, total, palette, ...).
// backgroundOnly: draws just the background (pattern thumbnails).
export default function CarouselThumb({
  options,
  backgroundOnly = false,
  className = "",
}) {
  const canvasRef = useRef(null);

  // Redraw on every render: the options change with the slides and the look
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.setTransform(SCALE, 0, 0, SCALE, 0, 0);
    if (backgroundOnly) {
      drawBackground(ctx, {
        style: options.bgStyle,
        theme: buildTheme(options.palette),
        index: options.index || 0,
        bgBitmap: options.bgBitmap,
        bgOverlay: options.bgOverlay,
        options: options.bgOptions,
      });
    } else {
      drawSlide(ctx, options);
    }
    ctx.setTransform(1, 0, 0, 1, 0, 0);
  });

  return (
    <canvas
      ref={canvasRef}
      width={CANVAS_W * SCALE}
      height={CANVAS_H * SCALE}
      aria-hidden="true"
      className={`block w-full h-auto rounded border border-black-40 ${className}`}
    />
  );
}